<app-layout-header>

  <ng-content></ng-content>

</app-layout-header>